angular.module('rjmNg.constants')
.constant("errorConstants"
  SERVER_ERROR_MESSAGE: "There is an issue with our servers. Please wait a few minutes and try again."
)
